import React, { useState } from 'react';
import { Heart } from 'lucide-react';

const ProductCard = ({ product, onClick, onWishlistToggle, isWishlisted = false }) => {
    const [hovered, setHovered] = useState(false);

    return (
        <div
            onClick={onClick}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            style={{
                backgroundColor: '#F5EDE0',
                border: `1px solid ${hovered ? '#A0845C' : '#D4C5B0'}`,
                cursor: 'pointer',
                transition: 'all 0.4s ease',
                overflow: 'hidden',
                boxShadow: hovered ? '0 4px 20px rgba(124, 45, 18, 0.08)' : 'none',
            }}
        >
            {/* Image */}
            <div style={{ position: 'relative', aspectRatio: '3 / 4', overflow: 'hidden' }}>
                <img
                    src={product.image}
                    alt={product.name}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        filter: hovered ? 'sepia(0.15)' : 'sepia(0.08)',
                        transform: hovered ? 'scale(1.03)' : 'scale(1)',
                        transition: 'all 0.5s ease',
                    }}
                />

                {/* Vintage corner accents */}
                <div style={{ position: 'absolute', top: '6px', left: '6px', width: '16px', height: '16px', borderTop: '1px solid #A0845C', borderLeft: '1px solid #A0845C', opacity: 0.5 }} />
                <div style={{ position: 'absolute', top: '6px', right: '6px', width: '16px', height: '16px', borderTop: '1px solid #A0845C', borderRight: '1px solid #A0845C', opacity: 0.5 }} />
                <div style={{ position: 'absolute', bottom: '6px', left: '6px', width: '16px', height: '16px', borderBottom: '1px solid #A0845C', borderLeft: '1px solid #A0845C', opacity: 0.5 }} />
                <div style={{ position: 'absolute', bottom: '6px', right: '6px', width: '16px', height: '16px', borderBottom: '1px solid #A0845C', borderRight: '1px solid #A0845C', opacity: 0.5 }} />

                {/* Wishlist */}
                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        onWishlistToggle && onWishlistToggle(e, product.id);
                    }}
                    style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        width: '34px',
                        height: '34px',
                        backgroundColor: 'rgba(250, 243, 235, 0.85)',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'background-color 0.3s ease',
                        backdropFilter: 'blur(4px)',
                    }}
                >
                    <Heart
                        size={16}
                        style={{
                            color: isWishlisted ? '#7C2D12' : '#78716C',
                            fill: isWishlisted ? '#7C2D12' : 'none',
                            transition: 'color 0.3s ease, fill 0.3s ease',
                        }}
                    />
                </button>

                {/* Badge */}
                {product.badge && (
                    <span
                        style={{
                            position: 'absolute',
                            top: '10px',
                            left: '10px',
                            backgroundColor: '#7C2D12',
                            color: '#FAF3EB',
                            fontFamily: "'Work Sans', sans-serif",
                            fontSize: '10px',
                            fontWeight: 500,
                            letterSpacing: '1px',
                            textTransform: 'uppercase',
                            padding: '4px 10px',
                        }}
                    >
                        {product.badge}
                    </span>
                )}
            </div>

            {/* Info */}
            <div style={{ padding: '14px' }}>
                <h3
                    style={{
                        fontFamily: "'Vollkorn', Georgia, serif",
                        fontSize: '14px',
                        fontWeight: 600,
                        color: '#1C1917',
                        margin: '0 0 6px 0',
                        lineHeight: 1.4,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {product.name}
                </h3>
                <span
                    style={{
                        fontFamily: "'Work Sans', sans-serif",
                        fontSize: '15px',
                        fontWeight: 500,
                        color: '#7C2D12',
                    }}
                >
                    {typeof product.price === 'number'
                        ? `\u20B9${product.price.toLocaleString('en-IN')}`
                        : product.price}
                </span>
            </div>
        </div>
    );
};

export default ProductCard;
